export default {
  data() {
    return {
      anyMenusOpen: false,
    };
  },
  watch: {
    menus: {
      handler(value) {
        this.anyMenusOpen = value && Object.keys(value).some((k) => value[k]);
        this.$emit("menuEvent", this.anyMenusOpen);
      },
      deep: true,
    },
  },
};
